import { actionTypes } from "./Actions";

const clearSpidToken = () => ({ type: actionTypes.CLEAR_SPID_TOKEN });

export default clearSpidToken;
